export default "__VITE_ASSET__BZQhHb8A__"